import React from "react";
import Footer from '../Footer';
import { Link } from 'react-router-dom';
import './App.css';

export default function What() {
    return <div> 
        <div className='inner__page__container'>
            <div className='inner__content__container'>
                <h1>What Is React?</h1>
                    <p>React, aka ReactJS or React.js, is a popular JavaScript library. Developed by Facebook, it’s widely used in front-end development to build attractive, interactive, and engaging user interfaces. React was created by Jordan Walke, from Facebook and open-sourced in May 2013. It’s commonly used in websites and especially single-page applications for building highly-interactive UIs.</p>
                    <h1>Features</h1>
            </div>                     
                        <div className="features__flexbox">
                            <div className="features__boxes">
                                <p>Use of JSX — XML like syntax for component rendering.</p>
                                <img src="./logo192-2.webp" width="50px" height="50px" alt="react-logo" />
                            </div>
                            <div className="features__boxes">
                                <p>Virtual DOM — only update and render that has changed.</p>
                                <img src="./logo192-2.webp" width="50px" height="50px" alt="react-logo" />
                            </div>
                            <div className="features__boxes">
                                <p>Declarative, stateful components for faster, effortless UI creation.</p>
                                <img src="./logo192-2.webp" width="50px" height="50px" alt="react-logo" />
                            </div>
                        </div>
                    <Link to='/why' className="inner-page-button">Next: Why React?</Link>   
        </div>
        <Footer />
    
    
    
    </div>;
}